import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

export default function FutureMineralsCountriesOpportunitiesGridItem({ opportunity }) {
  const { lng } = useParams()
  const { t } = useTranslation()
  return (
    <div
      data-aos="fade-up"
      className={'col-span-12 border-2 border-muted-300 md:col-span-6'}
    >
      <h3
        title={opportunity[`title_${lng}`]}
        className="line-clamp-1 select-all border-b-2 border-muted-300 bg-light p-4 px-6 font-bold"
      >
        {opportunity[`title_${lng}`]}
      </h3>
      <ul className="flex transform flex-col gap-4 p-4 px-6 transition duration-300 ease-in-out group-hover:bg-muted-300/10">
        <li className="flex flex-row space-x-2">
          <p>
            <span className="font-bold"> {t('ROW_MENIRALS')} : </span>
            <span>{opportunity[`raw_materials_${lng}`]}</span>
          </p>
        </li>
        <li className="flex flex-row space-x-2">
          <p>
            <span className="font-bold">{t('DATE')} : </span>
            <span>{opportunity.started_at == null ? t('NOT_SPECIFIED') : new Date(opportunity.started_at).getFullYear()}</span>
          </p>
        </li>
        <li className="flex flex-row space-x-2">
          <p>
            <span className="font-bold">{t('AREA')} : </span>
            <span>{opportunity.area == null ? t('NOT_SPECIFIED') : opportunity.area}</span>
          </p>
        </li>
        <li className="flex flex-row space-x-2">
          <p>
            <span className="font-bold">{t('TYPE')} : </span>
            <span>{opportunity[`type_${lng}`]}</span>
          </p>
        </li>
        {/* <li className="flex flex-row space-x-2">
          <p>
            <span className="font-bold">{t('STATUS')} : </span>
            <span>{!opportunity.is_expired ? t('ACTIVE') : t('INACTIVE')}</span>
          </p>
        </li> */}
      </ul>
      <div className="border-t-2 border-muted-300">
        <AdditionalLink
          link={opportunity?.attachment_link}
          label={t('ADDITIONAL_INFORMATION')}
        />
      </div>
    </div>
  )
}

const AdditionalLink = ({ link, label }) => {
  if (link == null) {
    return <p className="flex w-full cursor-default justify-center bg-light px-4 py-4 font-semibold text-dark">{label}</p>
  }
  return (
    <Link
      target="_blank"
      to={link}
      className="flex w-full transform justify-center bg-secondary-600/40 px-4 py-4 font-semibold text-dark transition duration-300 ease-in-out hover:bg-secondary-600/50"
    >
      {label}
    </Link>
  )
}
